import { Category } from './Category';
import { Discount } from './Discount';
import { ParameterValue } from './Parameter';
import { Producer } from './Producer';

export type Product = {
  id: number;
  name: string;
  slug: string;
  serialNumber: string;
  categoryId: number;
  producerId: number;
  description?: string;
  price: number;
  primaryImage: string;
  mobilePrimaryImage: string;
  keywords?: string;
  popularity: number;
  draft: boolean;
  tag?: Tag | null;

  parameterValues: ParameterValue[];
  secondaryImages: SecondaryImage[];
  producer: Producer;
  category: Category;

  packaged: boolean;
  packageDimensions?: [number, number, number];
  packageWeight?: number;
  singleItemDeliveryCost?: number;

  discount?: Discount;
  lowestPriceLast30Days?: number;
};

export enum Tag {
  New = 'New',
  Sale = 'Sale',
  Bestseller = 'Bestseller',
  Recommended = 'Recommended',
}

export type SecondaryImage = {
  id: number;
  image: string;
  productId: number;
  order: number;
};

export interface ProductFormData {
  name: string;
  serialNumber: string;
  categoryId: number;
  producerId: number;
  description?: string;
  price: number;
  primaryImage?: File | null;
  keywords?: string;
  secondaryImages: File[];
  secondaryImagesOrders: number[];
  parameterValues: { id: number; value: string }[];
  draft: boolean;
  tag: Tag | null;

  // Information about packaging
  packaged: boolean;
  packageDimensions?: [number, number, number];
  packageWeight?: number;
  singleItemDeliveryCost?: number;
}
